import Vue from 'vue'
import AddToCartModal from './AddToCartModal.vue'
import i18n from '../i18n'
import { config } from '../../util'
import axios from 'axios'
import $ from 'jquery'

// Create a global event bus for cart events
export const cartEventBus = new Vue()

Vue.config.productionTip = false

// Initialize i18n with default locale
const locale = document.documentElement.lang || 'nl-NL'
config.locale = locale
const i18nInstance = i18n(locale)

// Create a global cart modal component
const CartModalComponent = Vue.extend({
  i18n: i18nInstance,
  data () {
    return {
      addToCartModalVisible: false,
      hasIncassoProcess: false,
      isLegacyTrigger: false,
      options: {}
    }
  },
  methods: {
    show (options = {}) {
      this.options = options // Set the options

      // If modal is already visible, just update the incasso status
      if (this.addToCartModalVisible) {
        this.hasIncassoProcess = options.hasIncassoProcess || false
        return
      }

      this.isLegacyTrigger = options.isLegacy || false

      // Check if this is a legacy trigger and get incasso status from PHP
      if (this.isLegacyTrigger) {
        const incassoElement = document.querySelector('meta[name="incasso-process"]')
        this.hasIncassoProcess = incassoElement ? incassoElement.getAttribute('content') === 'true' : false
      } else {
        this.hasIncassoProcess = options.hasIncassoProcess || false
      }

      this.addToCartModalVisible = true
    },

    hide () {
      this.addToCartModalVisible = false
      this.hasIncassoProcess = false
      this.isLegacyTrigger = false
    }
  },
  render (h) {
    if (!this.addToCartModalVisible) return null

    return h(AddToCartModal, {
      props: {
        options: this.options,
        showIncassoWarning: this.hasIncassoProcess,
        showReservationMessage: ['reservation-queued', 'reservation-success'].includes(this.options.message_type)
      },
      on: {
        close: this.hide
      }
    })
  }
})

// Create and mount the cart modal
const cartModal = new CartModalComponent().$mount()
document.body.appendChild(cartModal.$el)

// Export a function to show the modal
export function showAddToCartModal (options = {}) {
  cartModal.options = options
  cartModal.show(options)
}

// Function to refresh cart data
export function refreshCartData () {
  // Fetch fresh cart data using the ajax endpoint
  axios.get('/php/xhr/ajax.php', {
    params: {
      function: 'dataduiker/shoppingCartAdded'
    }
  })
    .then(response => {
      const data = response.data
      // Update the cart count badge
      const cartButtons = document.querySelectorAll('[data-toggle="popover-cart"]')

      if (cartButtons.length > 0) {
        for (const cartButton of cartButtons) {
          let cartBadge = cartButton?.querySelector('.badge')

          // Create badge if it doesn't exist
          if (!cartBadge) {
            cartBadge = document.createElement('span')
            cartBadge.className = 'badge badge-success badge-pill'
            cartButton.appendChild(cartBadge)
          }

          if (data.count > 0) {
            cartBadge.textContent = data.count
            cartBadge.classList.remove('d-none')
            // Trigger bounce animation by removing and re-adding the animation class
            cartBadge.classList.remove('cart-badge-bounce')
            setTimeout(() => {
              cartBadge.classList.add('cart-badge-bounce')
              // Remove the class after animation completes
              setTimeout(() => {
                cartBadge.classList.remove('cart-badge-bounce')
              }, 500)
            }, 0)
          } else {
            cartBadge.classList.add('d-none')
          }

          // Update cart button label
          cartButton.setAttribute('data-title', data.label)

          // Update popover content if it exists
          const $popover = $(cartButton).data('bs.popover')
          if ($popover && data.template) {
            $popover.config.content = data.template
            // If popover is currently shown, update its content
            const tip = document.querySelector('.popover')
            if (tip) {
              const content = tip.querySelector('.popover-body')
              if (content) {
                content.innerHTML = data.template
              }
            }
          }
        }
      } else {
        console.error('No cart buttons found to update!') // eslint-disable-line no-console
      }
    })
}

// Listen for cart events
cartEventBus.$on('show-cart-modal', (options = {}) => {
  showAddToCartModal(options)
})

cartEventBus.$on('refresh-cart-data', () => {
  refreshCartData()
})

// Listen for the 'added_to_cart' hash change
function checkHashForCartModal () {
  if (window.location.hash.includes('#added_to_cart')) {
    if (!cartModal.addToCartModalVisible) {
      showAddToCartModal({ isLegacy: true })
    }
  }
}

// Initial check in case the hash is already present
checkHashForCartModal()
